import { WalletStatusType } from "types/types"
import { useEffect, useRef, useState } from "react"

export default function useWalletBox({
                                         onInit
                                     }:{
    onInit:(data:{
        setStatus:(status:WalletStatusType)=>void,
    })=>void
}) {
    const [status, setStateStatus] = useState<WalletStatusType>('start')
    const [error, setError] = useState('')
    const statusRef = useRef(status)
    const [nonce,setNonce] = useState<any>()

    const setStatus = (status: WalletStatusType) => {
        statusRef.current = status
        setStateStatus(status)
    }
    const init = ()=>{
        setError('')
        setNonce(null)
    }
    useEffect(()=>{
        init()

        onInit({
            setStatus
        })
        return ()=>{
            setStatus('start')
            setNonce(null)
            setError('')
        }
    },[])
    return {
        status,
        statusRef,
        setStatus,
        error,
        setError,
        nonce,
        setNonce,
        init
    }
}